import type { DesignerSeriesDto } from "../types";

export interface SeriesPickerProps {
  series: DesignerSeriesDto[];
  onPick: (series: DesignerSeriesDto) => void;
  /** Designer name, shown as the page title. */
  designerName?: string;
}

/**
 * Initial-screen series picker. Shown only when the Designer carries 2+ series;
 * a single-series Designer drops straight into the configurator without this
 * step. Each card represents one series (a configured root category) — picking
 * one scopes the catalog to that subtree.
 */
export function SeriesPicker({ series, onPick, designerName }: SeriesPickerProps) {
  return (
    <div className="sd-series">
      <div className="sd-series__inner">
        <header className="sd-series__header">
          {designerName && <p className="sd-series__eyebrow">{designerName}</p>}
          <h1 className="sd-series__title">Choose a series</h1>
          <p className="sd-series__subtitle">Pick a starting point to begin designing.</p>
        </header>

        <ul className="sd-series__grid">
          {series.map(s => (
            <li key={s.id}>
              <button type="button" className="sd-series__card" onClick={() => onPick(s)}>
                <div className="sd-series__card-thumb">
                  {s.iconUrl ? <img src={s.iconUrl} alt="" /> : <span>📁</span>}
                </div>
                <span className="sd-series__card-label">{s.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
